export interface ITableData{
    headers?: IHeader[];
    id?: number;
    body?: any;
    setBody(body:any):void
}

export class TableData implements ITableData{
    constructor(
        public headers?:IHeader[],
        public id?: number,
        public body?: any
    ){}
    setBody(body:any){
        this.body = body;
    }
}

export interface IHeader{
    title:IText;
    dataKey:IText;
    style:string |null| undefined;
    displayTextLimit: number;
    sortable?: boolean | false;
    map?: (data:any) => any;
}
export class Header{
    constructor(
        public title:IText,
        public dataKey:IText,
        public style:string |null|undefined, 
        public displayTextLimit = 0,
        public sortable?: boolean | false
    ){}
}

export interface IText{
    En:string;
    Hi:string;
}
export class Text{
    constructor(
        public En:string,
        public Hi:string
    ){}
}